import { defineFakeRoute } from "vite-plugin-fake-server/client";

// 模拟刷新token接口
export default defineFakeRoute([
  {
    url: "/mock/api/db/manager/user_list",
    method: "get",
    response: ({ body }) => {
      return {
        code: 20000,
        message: "success",
        total: 3,
        rows: [
          {
            id: "user_1",
            username: "test_1",
            nickname: "Test 1",
            password_hash: "ddac6971379d85b65fa74ddce58ff4a6",
            email: "1@1.com",
            is_active: true,
            last_login: null,
            remark: "password: aaaa1111",
            create_time: "2025-11-10T15:32:14.547+08:00",
            update_time: "2025-11-10T15:32:14.547+08:00",
            roles: ["student"]
          },
          {
            id: "user_2",
            username: "test_2",
            nickname: "Test 2",
            password_hash: "ddac6971379d85b65fa74ddce58ff4a6",
            email: "1@1.com",
            is_active: true,
            last_login: null,
            remark: "password: aaaa1111",
            create_time: "2025-11-10T15:32:14.547+08:00",
            update_time: "2025-11-10T15:32:14.547+08:00",
            roles: ["teach"]
          },
          {
            id: "user_3",
            username: "test_3",
            nickname: "Test 3",
            password_hash: "ddac6971379d85b65fa74ddce58ff4a6",
            email: "1@1.com",
            is_active: true,
            last_login: null,
            remark: "password: aaaa1111",
            create_time: "2025-11-10T15:32:14.547+08:00",
            update_time: "2025-11-10T15:32:14.547+08:00",
            roles: ["manager"]
          }
        ]
      };
    }
  }
]);
